import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, Package, Truck, Home } from 'lucide-react';
import { BACKEND_URL } from '../config';
import Navbar from '../components/Navbar';

export default function OrderSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const orderId = searchParams.get('order_id');
  const paymentId = searchParams.get('razorpay_payment_id');

  useEffect(() => {
    const confirmPayment = async () => {
      if (!orderId) {
        setLoading(false);
        return;
      }

      try {
        // Mark payment as successful
        await fetch(`${BACKEND_URL}/api/orders/${orderId}/payment-success?payment_id=${paymentId || ''}`, {
          method: 'POST'
        });

        // Fetch order details
        const res = await fetch(`${BACKEND_URL}/api/orders/${orderId}`);
        if (res.ok) {
          const data = await res.json();
          setOrder(data);
        }
      } catch (err) {
        console.error('Error confirming payment:', err);
      } finally {
        setLoading(false);
      }
    };

    confirmPayment();
  }, [orderId, paymentId]);

  if (loading) {
    return (
      <div className="page-wrapper">
        <Navbar />
        <div className="order-success-page">
          <div className="success-loading">
            <div className="spinner"></div>
            <p>Confirming your payment...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="order-success-page">
        <div className="success-card">
          <div className="success-icon">
            <CheckCircle size={64} />
          </div>
          
          <h1>Order Placed Successfully!</h1>
          <p className="success-subtitle">Thank you for your order</p>
          
          {order ? (
            <div className="order-details-card">
              <div className="order-id-row">
                <span>Order ID:</span>
                <strong>{order.order_id}</strong>
              </div>
              
              <div className="order-product-row">
                <Package size={20} />
                <div>
                  <strong>{order.product_name}</strong>
                  <span>Qty: {order.quantity}</span>
                </div>
                <span className="order-price">₹{order.total_amount}</span>
              </div>

              <div className="delivery-info">
                <Truck size={20} />
                <div>
                  <strong>Delivery Address</strong>
                  <p>{order.customer?.name}</p>
                  <p>{order.customer?.address}, {order.customer?.city}</p>
                  <p>{order.customer?.state} - {order.customer?.pincode}</p>
                  <p>{order.customer?.phone}</p>
                </div>
              </div>

              <div className="delivery-estimate">
                <div className="estimate-icon">🚚</div>
                <div>
                  <strong>Estimated Delivery</strong>
                  <p>2-5 Business Days</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="order-details-card">
              <p>Your order has been placed successfully.</p>
              <p>You will receive a confirmation on your registered email/phone.</p>
            </div>
          )}

          <div className="success-actions">
            <button className="btn-primary" onClick={() => navigate('/')}>
              <Home size={18} /> Back to Home
            </button>
            <button className="btn-secondary" onClick={() => navigate('/marketplace-info')}>
              Continue Shopping
            </button>
          </div>

          <p className="support-note">
            For any queries, contact us at <strong>feedback@boai.in</strong> or <strong>9599153699</strong>
          </p>
        </div>
      </div>
    </div>
  );
}
